export default "__VITE_ASSET__BQUFjyjp__"